import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"

import { Link } from "react-router-dom"

// components
import Applications from "pages/Dashboard/applications"

// services
import ApplicationService from "../../services/applications/Application.service"
import Staff from "services/staff/Staff"
import EnvAuditApplicationFilter from "components/Filter/EnvAuditApplicationFilter"

let appService = null
let plasticsUser = null
let staffService = new Staff()

const AllEnvApplications = () => {
  const [menu, setMenu] = useState(false)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [permissions, setpermissions] = useState()
  const [allApplications, setallApplications] = useState()

  const [searchMode, setsearchMode] = useState(false)
  const [filterValues, setFilterValues] = useState({
    applicant: "",
    title_of_project: "",
    project_province: "",
    rapep_firm: "",
    application_status: "",
    submitted_from: "",
    submitted_to: "",
  })

  const toggle = () => {
    setMenu(!menu)
  }

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)

    setuser(userObj)
    appService.getAllEnvAuditApplications(0).then(response => {
        console.log(response)
      if (response.status) {
        setallApplications(response.data)
        setmounted(true)
      }
    })
  }, [])

  const paginate = page => {
    // If we are in search mode, we will call the search endpoint instead
    if (searchMode) {
      appService.searchEnvironmentAuditApplications(filterValues, page).then(response => {
        setallApplications(response.data)
      })
    } else {
      appService.getAllEnvAuditApplications(page).then(response => {
        if (response.status) {
          setallApplications(response.data)
        }
      })
    }
    
  }

  const initiateSearch = (data) => {
    setsearchMode(true)
    setFilterValues(data)
    appService.searchEnvironmentAuditApplications(data, 1).then(response => {
        console.log("response", response)
      if (response?.code && response.code == 200) {
        if (response.data.total == 0) {
          setallApplications({data: []})
        } else {
          setallApplications(response.data)
        }
      } else {
        setallApplications({data: []})
      }
    })
  }

  const turnOffSearchMode = () => {
    setsearchMode(false)
    paginate(0)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>All Environmental Audit Applications | Staff</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">All Environmental Audit Applications</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    All applications will show up here. This includes applications NOT assigned to you.
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

          {mounted ? (
            <Row>
              <EnvAuditApplicationFilter allApplications={true} handleSearch={initiateSearch} turnOffSearch={turnOffSearchMode} />
              <Applications
                viewOnly={true}
                user={user}
                data={allApplications}
                paginate={paginate}
              />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AllEnvApplications
